module.factory('bankLoginService', [
  '$state', '$http', 'baseURI', 'Transform', 'bankToAddService',
  function($state, $http, baseURI, Transform, bankToAddService) {

    var service = {
      loading: false,
      attempted: false,
      showNext: false,
      toggleNext: toggleNext,
      attemptSubmission: attemptSubmission,
      submitAccount: submitAccount
    };

    return service;

    function toggleNext() {
      service.showNext = !service.showNext;
    }

    function attemptSubmission(form, formData) {
      if (form.$valid) {
        if (Array.isArray(formData)) {

          // Multiple account submission
          var accounts = formData;

          bankToAddService.resetAccounts();

          for (var i = 0, len = accounts.length; i < len; i++) {
            var account = accounts[i];
            // account.isSelected: if user toggled the checkbox
            if (account && account.isSelected) {
              submitAccount(account);
              bankToAddService.saveAccount(account);
            }
          }

        } else {
          // Single account submission
          submitAccount(formData);
        }

      } else {
        service.attempted = true;
      }
    }

    function submitAccount(account) {
      var url = baseURI + 'bank/link';

      service.loading = true;

      $http({
        url: url,
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(account)
      }).then(function (resp){
        if(resp.data.Success){
          service.loading = false;
          $state.go('member.home.bank/add.confirmation');
        } else {
          service.loading = false;
          $state.go('member.home.bank/add.error');
        }
      }).catch(function (error){
        service.loading = false;
        $state.go('member.home.bank/add.error');
      });
    }

}]);
